/**
 * In-memory cache of ETags for Google Drive files.
 * Used to detect concurrent modifications via If-Match / 412.
 * Keyed by fileId. Cleared on logout (via core.reset()).
 */
const cache = new Map<string, string>();

export const etagCache = {
  get(fileId: string): string | undefined { return cache.get(fileId); },
  set(fileId: string, etag: string): void { cache.set(fileId, etag); },
  delete(fileId: string): void { cache.delete(fileId); },
  clear(): void { cache.clear(); },
};
